function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, React.createElement("path", {
  fill: "#FFCE42",
  d: "M5.31890625 14.5035L4.4835 17.6221875l-3.05339062.0645938C.51759375 15.9942656 0 14.0578125 0 12c0-1.9898906.4839375-3.86639062 1.34175-5.5186875h.00065625l2.718375.498375L5.25159375 9.68175c-.24923437.7266094-.38507813 1.5066094-.38507813 2.31825.00009376.880875.15965626 1.7248594.45239063 2.5035z"
}), React.createElement("path", {
  fill: "#4D8CF5",
  d: "M23.7903281 9.75825C23.9281406 10.4841563 24 11.2338281 24 12c0 .859125-.0903281 1.6971563-.2624062 2.5055156-.5841563 2.7507657-2.1105469 5.1527344-4.2250313 6.8525157l-.0006563-.0006563-3.4239375-.1747031-.4845937-3.0250781c1.4030625-.8228438 2.4995625-2.1105469 3.0771563-3.6520782h-6.4167188V9.75825h11.5265156z"
}), React.createElement("path", {
  fill: "#23A565",
  d: "M19.5118594 21.357375l.0006562.0006563C17.4560625 23.0109844 14.8437187 24 12 24c-4.56989063 0-8.5430625-2.5542656-10.56989063-6.3131719l3.88879688-3.1832812C6.33229687 17.2081406 8.9413125 19.1334375 12 19.1334375c1.3147031 0 2.5463906-.3554062 3.6032812-.9758437l3.9085782 3.1997812z"
}), React.createElement("path", {
  fill: "#DD5044",
  d: "M19.6595625 2.762625L15.7720781 5.94525C14.67825 5.26153125 13.38525 4.8665625 12 4.8665625c-3.12792188 0-5.78573438 2.01360938-6.74835938 4.8151875L1.34240625 6.4813125H1.34175C3.33890625 2.63076562 7.3621875 0 12 0c2.9116406 0 5.5813125 1.03715625 7.6595625 2.762625z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/google-icon.412ea954.svg";
export { SvgComponent as ReactComponent };